<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      @if (!absenceEntryId) {
      <ion-button
        (click)="createTimeEntry()"
        [disabled]="
          userError ||
          timeError ||
          singleCollisionError ||
          workingTimeFoundErrorList.length > 0
        "
        >{{ "absence.createRequest" | translate }}</ion-button
      >
      } @if (absenceEntryId) {
      <ion-button
        (click)="updateTimeEntry()"
        [disabled]="
          userError ||
          timeError ||
          singleCollisionError ||
          (absenceEntryId && showWeekendInfo) ||
          workingTimeFoundErrorList.length > 0
        "
        >{{ "absence.updateRequest" | translate }}</ion-button
      >
      }
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="container">
    @if (state.userHasMinType(1)) {
    <div class="select-form">
      <lib-user-picker
        [users]="this.state.users$"
        [showAllEntry]="false"
        [multiple]="absenceEntryId == null"
        (selectedUserChanged)="userChange($event)"
        [preselectedUsers]="selectedUsers"
      ></lib-user-picker>
    </div>
    } @if(!absenceEntryId){
    <div class="select-form wide">
      <div>{{ "common.start" | translate }}</div>
      <div>{{ "common.end" | translate }}</div>
    </div>
    <div class="select-form wide">
      <!--lib-date-range-picker></lib-date-range-picker-->
      <lib-date-time-picker
        [type]="'date'"
        [inputDateZulu]="preselectedDate"
        (selectedDateChanged)="startDateChanged($event)"
      ></lib-date-time-picker>
      <div>
        <lib-date-time-picker
          [type]="'date'"
          [inputDateZulu]="preselectedDate"
          (selectedDateChanged)="endDateChanged($event)"
        ></lib-date-time-picker>
      </div>
    </div>
    @if(timeError){
    <div class="select-form collision-warning">
      <div class="centered">
        <ion-icon
          size="small"
          name="alert-circle-outline"
          style="margin-right: 4px"
        ></ion-icon>
        {{ "absence.endBeforeStart" | translate }}
      </div>
    </div>
    } }@else{
    <div class="select-form wide">
      <lib-date-time-picker
        [type]="'date'"
        [inputDateZulu]="absenceEntry.date"
        (selectedDateChanged)="dateChanged($event)"
      ></lib-date-time-picker>
    </div>
    } @if(!timeError && !absenceEntryId){
    <div class="select-form">
      {{ dayCount }}
      @if(dayCount > 1) {
      {{ "common.days" | translate }}
      } @else {
      {{ "common.day" | translate }}
      }
      {{ "absence.absent" | translate }}
    </div>
    } @if(showWeekendInfo){
    <div class="select-form no-workday-warning">
      <div class="centered">
        <ion-icon
          size="small"
          name="information-circle-outline"
          style="margin-right: 4px"
        ></ion-icon>
        {{ "common.weekendNotCreated" | translate }}
      </div>
    </div>
    } @if(singleCollisionError){
    <div class="select-form collision-warning">
      <div class="centered">
        <ion-icon
          size="small"
          name="alert-circle-outline"
          style="margin-right: 4px"
        ></ion-icon>
        {{ "absence.dateAlreadyExists" | translate }}
      </div>
    </div>
    }@if(collisionErrorList.length > 0){
    <div class="select-form collision-warning">
      <div>{{ "absence.notCreated" | translate }}</div>
      @for(error of collisionErrorList; track error){
      <div class="centered">
        <ion-icon
          size="small"
          name="alert-circle-outline"
          style="margin-right: 4px"
        ></ion-icon>

        {{ error }}
      </div>
      }
    </div>
    } @if(workingTimeFoundErrorList.length > 0){
    <div class="select-form collision-warning">
      @for(error of workingTimeFoundErrorList; track error){
      <div class="centered">
        <ion-icon
          size="small"
          name="alert-circle-outline"
          style="margin-right: 4px"
        ></ion-icon>

        {{ error }}
      </div>
      }
    </div>
    }

    <div class="select-form">
      @if(!absenceEntryId){
      <ion-select
        [label]="'common.type' | translate"
        label-placement="floating"
        mode="md"
        fill="outline"
        [(ngModel)]="this.absenceEntryRequest.type"
        interface="popover"
      >
        @for (type of this.typeOptions; track type) {
        <ion-select-option [value]="type">{{ type }}</ion-select-option>
        }
      </ion-select>
      }@else{
      <ion-select
        [label]="'common.type' | translate"
        label-placement="floating"
        mode="md"
        fill="outline"
        [(ngModel)]="this.absenceEntry.type"
        interface="popover"
      >
        @for (type of this.typeOptions; track type) {
        <ion-select-option [value]="type">{{ type }}</ion-select-option>
        }
      </ion-select>
      }
    </div>
    <div class="select-form">
      <ion-textarea
        [label]="'common.description' | translate"
        labelPlacement="floating"
        fill="outline"
        [autoGrow]="true"
        mode="md"
        [(ngModel)]="absenceEntry.description"
        [placeholder]="'common.addDescription' | translate"
      ></ion-textarea>
    </div>
  </div>
</ion-content>
